<div class="header-container">
  <h1 class="header-title">Default Find Tile</h1>
</div>
<div class="content">
  <nz-select [(ngModel)]="selectedType" name="type" style="width: 200px" (ngModelChange)="onTypeChange()">
    @for (tab of tabs; track tab) {
      <nz-option [nzValue]="tab" [nzLabel]="tab"></nz-option>
    }
  </nz-select>

  <nz-spin nzTip="Loading..." [nzSpinning]="loading">
    <div class="configurator">
      <div class="sidebar">
        <div class="trash" id="trash">
          <span nz-icon nzType="delete" class="icon-2x"></span>
        </div>
        <div class="grid-items">
          <div class="sidebar-item grid-stack-item add-item single">
            <div class="label">Label</div>
            <div>value</div>
          </div>
          <div class="sidebar-item grid-stack-item add-item double">
            <div>
              <span class="label">Label</span> / <span class="label">Label</span>
            </div>
            <div>
              <span>value</span> / <span>value</span>
            </div>
          </div>
        </div>
      </div>
      <hr>
      <div class="card">
        <div class="image-container"></div>
        @if (gridReady) {
          <gridstack style="flex: 1" [options]="gridOpt"></gridstack>
        }
      </div>
      <div class="action-buttons">
        <button nz-button (click)="resetToDefaults()">
          Reset to Default
        </button>
        <button nz-button [nzLoading]="saving" (click)="saveConfig()" nzType="primary">
          Save
        </button>
      </div>
    </div>
  </nz-spin>
</div>
